import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class SubmittingWarningsForm extends AppForm {
  constructor() {
    super({
      description: new FormControl(null, [Validators.required, Validators.maxLength(5000)])
    });
  }
}
